import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { ForgotPassword } from "../src/platform/views/Auth/ForgotPassword";
import Provider from "../src/redux/Provider";

const ForgotPasswordPage = ({ initialReduxState }) => {
  return (
    <Provider.Redux initialReduxState={initialReduxState}>
      <NextHead currentPath="/forgot-password" title="Forgot Password" />
      <ForgotPassword />
    </Provider.Redux>
  );
};

export default ForgotPasswordPage;
